// @flow

import { takeLatest, call, select, put } from 'redux-saga/effects';
import { DISABLE_ALL_NOTIFICATIONS } from './actionTypes';
import ApiNotifications from '~/sdk/notifications/email/ApiNotifications';
import clientConfig from '~/../parameters/client/config';
import { notificationApiParamsSelector } from '../selectors';
import { newsletterNotificationsSelector } from '../NewsletterNotifications/selectors';
import { searchNotificationsSelector } from '../SearchNotifications/selectors';
import { disableAllNewsletterNotifications, disableAllSearchNotifications } from './utils';
import { openSnackbarError, closeSnackbar, openSnackbar } from '../Snackbar/actions';
import {
  setNewsletterNotifications,
  restoreNewsletterNotifications,
} from '../NewsletterNotifications/actions';
import { setSearchNotifications, restoreSearchNotifications } from '../SearchNotifications/actions';
import messages from './messages';

const notificationsApi = new ApiNotifications(clientConfig.notificationApi);

export function* disableAllNotifications(): Generator<*, *, *> {
  const searchNotifications = yield select(searchNotificationsSelector);
  const newsletterNotificationsState = yield select(newsletterNotificationsSelector);

  yield put(closeSnackbar());

  const disabledSearchNotifications = disableAllSearchNotifications(searchNotifications);
  const disabledNewsletterNotifications = disableAllNewsletterNotifications(
    newsletterNotificationsState
  );

  yield put(setSearchNotifications(disabledSearchNotifications));
  yield put(setNewsletterNotifications(disabledNewsletterNotifications));

  // call API to disable notifications right after changing the view
  // so the response delay does not alter the user interaction
  const apiParams = yield select(notificationApiParamsSelector);

  try {
    yield call([notificationsApi, notificationsApi.disableAllNotifications], apiParams);
    yield put(openSnackbar(messages.disableNotificationsConfirmation));
  } catch (error) {
    yield put(openSnackbarError());
    yield put(restoreSearchNotifications(searchNotifications));
    yield put(restoreNewsletterNotifications(newsletterNotificationsState));
  }
}

export default function* rootSaga(): Generator<*, *, *> {
  yield takeLatest(DISABLE_ALL_NOTIFICATIONS, disableAllNotifications);
}



// WEBPACK FOOTER //
// ./app/NotificationsManager/email/DisableNotifications/sagas.js